/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment, useEffect, useRef, useState } from "react";
import storage from "../../../services/storage";
import { Link } from "react-router-dom";
import { toggleBookMode } from "../../../Store/settings/siteSettings";
import searchImg from "../../../assets/images/search_icon.svg";
import textImg from "../../../assets/images/text.svg";
import teextImg from "../../../assets/images/teext.svg";
import Help from "../../../assets/images/help.svg";
import dashboard from "../../../assets/images/dashboard.svg";
import bellImg from "../../../assets/images/bell.svg";
import arrowDown from "../../../assets/images/arrow-down.svg";
import arrowUp from "../../../assets/images/arrow-up.svg";
import "./DashboardHeader.css";
import { useDispatch, useSelector } from "react-redux";
import {
  allActivities,
  allStudents,
  countGraded
} from "../../../Store/api/professor/dashboard";
import { ProfileDropdown } from "../../../shared/ProfileDropdown";

const DashboardHeader = ({
  onSelectClass,
  onSelectSection,
  selectedClass,
  selectedSections,
  notAllowed = false,
  setLink = () => {}
}) => {
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const [user, setUser] = useState("");
  const [token, setToken] = useState("");
  const [expandedClasses, setExpandedClasses] = useState([]);
  const [isDropDownShown, setIsDropDownShown] = useState(false);
  const { settings } = useSelector((state) => state.settings.settings);
  const { classes = [] } = useSelector((state) => state.entities.classes);
  const selectedClassObj = classes?.find((e) => e._id === selectedClass._id);
  const toggleClass = (classId) => {
    setExpandedClasses((prevExpandedClasses) =>
      prevExpandedClasses.includes(classId)
        ? prevExpandedClasses.filter((id) => id !== classId)
        : [...prevExpandedClasses, classId]
    );
  };
  useEffect(() => {
    const Storeuser = storage.get("user");
    const Storetoken = storage.get("xAuthToken");
    setUser(Storeuser);
    setToken(Storetoken);
  }, [settings]);
  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropDownShown(false); // Close the dropdown
    }
  };
  useEffect(() => {
    // Add event listener for clicks outside the dropdown
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    dispatch(allStudents({ onSuccess: () => {}, onError: () => {} }));
  }, [dispatch]);
  useEffect(() => {
    dispatch(allActivities({ onSuccess: () => {}, onError: () => {} }));
  }, [dispatch]);
  useEffect(() => {
    dispatch(countGraded({ onSuccess: () => {}, onError: () => {} }));
  }, [dispatch]);

  let sections = [];
  for (let index = 0; index < classes.length; index++) {
    const element = classes[index];
    sections = [...sections, ...element.sections.map((e) => e._id)];
  }

  const renderClassList = (classList, type) => (
    <ul>
      {classList
        ?.filter((cls) => cls?.sections?.length > 0)
        .map((el, index) => {
          const isCurrentClass = isWithinCurrentClassRange(el);
          const isUpcomingClass = isWithinUpcomingClassRange(el);

          // if (
          //   (type === "current" && isCurrentClass) ||
          //   (type === "upcoming" && isUpcomingClass)
          // ) {
          //   return renderClassItem(el, index);
          // }

          return renderClassItem(el, index);
        })}
    </ul>
  );

  const renderClassItem = (el, index) => (
    <Fragment key={index}>
      <div className="iagree_radio instructors class-item-drop">
        <div className="class-info-drop">
          <input
            type="checkbox"
            id={`class-${el._id}`}
            checked={selectedClass?._id === el._id}
            onChange={() => onSelectClass(el)}
            onClick={(e) => e.stopPropagation()}
          />
          <label
            htmlFor={`class-${el._id}`}
            className="squre-box drop_down_list">
            {el.courseNumber}
          </label>
          <img
            className="drop_down_list"
            style={{ background: "var(--Grey-100, #FAFAF9))" }}
            src={expandedClasses.includes(el._id) ? arrowUp : arrowDown}
            alt="arrow"
            onClick={(e) => {
              e.stopPropagation();
              toggleClass(el._id);
            }}
          />
        </div>
        <div>
          <Link
            to={`/create/${el.book}`}
            target="_blank"
            className="text-decoration-none">
            <span className="f_12 view-book-drop">VIEW BOOK</span>
          </Link>
        </div>
      </div>
      {expandedClasses.includes(el._id) && renderSectionList(el.sections)}
    </Fragment>
  );

  const renderSectionList = (sections) => (
    <ul className="sections-list">
      {sections.map((section) => (
        <li key={section._id} className="section-item-drop">
          <div
            className="iagree_radio instructors section-info-drop"
            style={{ background: "#fff", fontWeight: "500" }}>
            <input
              type="checkbox"
              id={`section-${section._id}`}
              checked={selectedSections.includes(section._id)}
              onChange={(e) => {
                e.stopPropagation();
                onSelectSection(section._id);
              }}
            />
            <label
              htmlFor={`section-${section._id}`}
              style={{ fontWeight: "500" }}
              className="squre-box drop_down_list">
              {section.sectionName} {section.sectionNumber.split("-")[0]}
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
  const isWithinCurrentClassRange = (el) => {
    const today = new Date().setHours(0, 0, 0, 0);
    return (
      new Date(el.startDate).setHours(0, 0, 0, 0) <= today &&
      new Date(el.endDate).setHours(0, 0, 0, 0) >= today
    );
  };

  const isWithinUpcomingClassRange = (el) => {
    const today = new Date().setHours(0, 0, 0, 0);
    return (
      new Date(el.startDate).setHours(0, 0, 0, 0) > today &&
      new Date(el.endDate).setHours(0, 0, 0, 0) >= today
    );
  };
  const toggle = () => {
    setIsDropDownShown((prev) => !prev);
  };
  return (
    <div>
      <header>
        <div className="d-flex gap-1 align-items-center justify-content-between header_wrapper">
          <div className="d-flex search_wrapper w-55">
            <input type="text" placeholder="Search in book" />
            <img src={searchImg} alt="filter" />
          </div>
          <div className="d-flex align-items-center">
            <div className="icon_text cursor">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  if (settings.siteMode !== "teach") return;
                  dispatch(toggleBookMode());
                }}>
                <img
                  src={settings.bookMode ? teextImg : textImg}
                  alt="text"
                  className="text_icon mr-15"
                />
              </a>
            </div>
            <div className="icon_text cursor">
              <a
                href="https://docs.greyled.com"
                target="_blank"
                rel="noreferrer"
                referrerPolicy="no-referrer">
                <img src={Help} alt="help" className="text_icon " />
              </a>
            </div>
          </div>
          <div className="w-25 new_header_inner">
            <div className="dropdown explore_btn w-100" ref={dropdownRef}>
              <div className="form-group" onClick={toggle}>
                <div className="form_control w-100" style={{ height: "none" }}>
                  <div className="select_class_parent d-flex justify-content-between w-100">
                    <p className="f_12 w-100">
                      {selectedClassObj
                        ? selectedClassObj?.courseName
                        : "Class & Section Select"}
                    </p>
                    <img
                      className="toggle_class_sel_arrow"
                      src={isDropDownShown ? arrowUp : arrowDown}
                      alt="arrow"
                    />
                  </div>
                </div>
              </div>
              {isDropDownShown && (
                <div className="inner-option">
                  <p className="f13">Grade from chosen sections</p>

                  {sections.length > 0 && (
                    <>
                      <p className="f_12">ALL CLASSES</p>
                      <div>{renderClassList(classes, "upcoming")}</div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          <div>
            {user && token ? (
              <div className="user_wrap">
                <Link className="cursor text-decoration-none" to={"/dashboard"} onClick={(e)=>{
                  if(notAllowed){
                    e.preventDefault();
                    setLink("/dashboard")
                  }
                  }}>
                  <img
                    src={dashboard}
                    alt="dashboard"
                    className="question mr-15"
                  />
                </Link>
                <img src={bellImg} alt="bell" className="bell mr-15 cursor" />
                <div className="dropdown explore_btn cursor">
                  <ProfileDropdown user={user} />
                </div>
              </div>
            ) : (
              <div className="btn_class"></div>
            )}
          </div>
        </div>
      </header>
    </div>
  );
};

export default DashboardHeader;
